import { Calendar, User, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const Blog = () => {
  const blogPosts = [
    {
      title: "5 Lessons from Successful Student Entrepreneurs",
      excerpt: "Discover the key insights and strategies that helped student founders build thriving startups while managing their studies.",
      author: "KAROBAR Team",
      date: "May 15, 2026",
      category: "Entrepreneurship",
      image: "https://images.unsplash.com/photo-1556761175-b413da4baf72?q=80&w=2074"
    },
    {
      title: "How to Pitch Your Startup Idea Effectively",
      excerpt: "Master the art of pitching with these proven techniques used by successful entrepreneurs to win investors and customers.",
      author: "Priya Desai",
      date: "May 10, 2026",
      category: "Skills",
      image: "https://images.unsplash.com/photo-1475721027785-f74eccf877e2?q=80&w=2070"
    },
    {
      title: "Building a Strong Network in College",
      excerpt: "Networking is crucial for entrepreneurial success. Learn how to build meaningful connections that last beyond graduation.",
      author: "Rahul Menon",
      date: "May 5, 2026",
      category: "Networking",
      image: "https://images.unsplash.com/photo-1511578314322-379afb476865?q=80&w=2069"
    },
    {
      title: "The Future of Startups in India",
      excerpt: "An analysis of emerging trends and opportunities in India's startup ecosystem for the next generation of entrepreneurs.",
      author: "Ananya Krishnan",
      date: "April 28, 2026",
      category: "Trends",
      image: "https://images.unsplash.com/photo-1559136555-9303baea8ebd?q=80&w=2070"
    },
    {
      title: "From Idea to MVP: A Step-by-Step Guide",
      excerpt: "Learn how to transform your startup idea into a minimum viable product that validates your concept and attracts early users.",
      author: "Vikram Singh",
      date: "April 20, 2026",
      category: "Product Development",
      image: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?q=80&w=2070"
    },
    {
      title: "Funding Options for Student Startups",
      excerpt: "Explore various funding sources available for student entrepreneurs, from grants and competitions to angel investors.",
      author: "KAROBAR Team",
      date: "April 15, 2026",
      category: "Funding",
      image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=2070"
    },
  ];

  return (
    <div className="pt-20" data-testid="blog-page">
      <section className="section-padding bg-gradient-to-b from-black to-[#121212]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-gold-500 mb-4">INSIGHTS & STORIES</p>
            <h1 className="text-5xl sm:text-6xl md:text-7xl font-black tracking-tighter uppercase mb-6" style={{ fontFamily: 'Open Sans' }}>BLOG</h1>
            <p className="text-gray-400 text-lg max-w-3xl mx-auto">Learn from experiences, gain insights, and stay updated with the latest in entrepreneurship and innovation.</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
            {blogPosts.slice(0, 2).map((post, index) => (
              <div key={index} className="glass-card overflow-hidden group" data-testid={`featured-post-${index}`}>
                <div className="relative h-64 overflow-hidden">
                  <img src={post.image} alt={post.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                  <div className="absolute top-4 left-4 bg-gold-500 text-black px-3 py-1 text-xs font-bold">
                    {post.category}
                  </div>
                </div>
                <div className="p-8">
                  <h2 className="text-2xl font-black mb-4 group-hover:text-gold-500 transition-colors" style={{ fontFamily: 'Open Sans' }}>{post.title}</h2>
                  <p className="text-gray-400 mb-6 leading-relaxed">{post.excerpt}</p>
                  <div className="flex items-center justify-between text-sm">
                    <div className="flex items-center space-x-4 text-gray-500">
                      <div className="flex items-center space-x-2">
                        <User size={16} />
                        <span>{post.author}</span>
                      </div>
                      <div className="flex items-center space-x-2">
                        <Calendar size={16} />
                        <span>{post.date}</span>
                      </div>
                    </div>
                    <button className="text-gold-500 hover:text-gold-400 flex items-center space-x-2" data-testid={`read-more-${index}`}>
                      <span>READ MORE</span>
                      <ArrowRight size={16} />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {blogPosts.slice(2).map((post, index) => (
              <div key={index} className="glass-card overflow-hidden group" data-testid={`blog-post-${index + 2}`}>
                <div className="relative h-48 overflow-hidden">
                  <img src={post.image} alt={post.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                  <div className="absolute top-4 left-4 bg-gold-500 text-black px-3 py-1 text-xs font-bold">
                    {post.category}
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-black mb-3 group-hover:text-gold-500 transition-colors" style={{ fontFamily: 'Open Sans' }}>{post.title}</h3>
                  <p className="text-gray-400 text-sm mb-4 leading-relaxed">{post.excerpt}</p>
                  <div className="flex items-center space-x-3 text-xs text-gray-500 mb-4">
                    <span>{post.author}</span>
                    <span>•</span>
                    <span>{post.date}</span>
                  </div>
                  <button className="text-gold-500 hover:text-gold-400 text-sm font-semibold" data-testid={`read-more-${index + 2}`}>
                    READ MORE →
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;